export enum ApiErrorType {
    UnknownError = 0,
    Assignment_CanNotReassign = 101,
    Survey_InActive = 201,
    Survey_InvalidAcceptRole = 202,
    Survey_Public_NoAccess = 301,
    Survey_Public_SurveyNotFound = 302,
    Survey_Public_ActorNotFound = 303,
    Survey_Public_SurveyAlreadySubmitted = 304
}